import { useLabsFeature } from './useLabsFeature.js';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { useRouter } from '@fabric-app/compat';
import { appRoutes } from '../../app/routing/routes.config.js';

const usePageGuardLabsFeature = (feature) => {
  const { isEnabled, isLoading } = useLabsFeature(feature);
  const router = useRouter();
  useClientLayoutEffect(() => {
    if (isLoading || isEnabled || !feature) return;
    router.replace(appRoutes.notFound);
  }, [
    isEnabled,
    feature,
    isLoading,
    router
  ]);
};

export { usePageGuardLabsFeature };
//# sourceMappingURL=usePageLabsFeature.js.map
